package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.SortTypeDomain

@Serializable
enum class SortTypeDto {
    @SerialName("newest") NEWEST,
    @SerialName("high_price") HIGH_PRICE,
    @SerialName("low_price") LOW_PRICE,
}

fun SortTypeDomain.toDto() = when (this) {
    SortTypeDomain.NEWEST -> SortTypeDto.NEWEST
    SortTypeDomain.HIGH_PRICE -> SortTypeDto.HIGH_PRICE
    SortTypeDomain.LOW_PRICE -> SortTypeDto.LOW_PRICE
}